import HeroMain from "./HeroMain";
export default HeroMain;